import moduleBreadcrumbs from '../moduleBreadcrumbs';

export default [
  ...moduleBreadcrumbs,
  {
    text: 'Estorno',
    disabled: true,
  },
];
